

import { createContext, useContext, useMemo, useReducer } from "react";

const CartContext = createContext(null);

const initialState = {
  items: [], // { id, name, price, quantity, image }
};

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD_ITEM": {
      const existing = state.items.find((i) => i.id === action.payload.id);
      if (existing) {
        return {
          ...state,
          items: state.items.map((i) =>
            i.id === action.payload.id ? { ...i, quantity: i.quantity + 1 } : i
          ),
        };
      }
      return {
        ...state,
        items: [...state.items, { ...action.payload, quantity: 1 }],
      };
    }
    case "UPDATE_QUANTITY": {
      return {
        ...state,
        items: state.items.map((i) =>
          i.id === action.payload.id
            ? { ...i, quantity: Math.max(1, i.quantity + action.payload.delta) }
            : i
        ),
      };
    }
    case "REMOVE_ITEM":
      return {
        ...state,
        items: state.items.filter((i) => i.id !== action.payload.id),
      };
    case "CLEAR_CART":
      return { ...state, items: [] };
    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [state, dispatch] = useReducer(cartReducer, initialState);

  const subTotal = useMemo(
    () => state.items.reduce((sum, i) => sum + (i.price || 0) * i.quantity, 0),
    [state.items]
  );

  const value = useMemo(
    () => ({
      // CartPage.jsx isi naam se expect karta hai
      cartItems: state.items,
      // Navbar / kahin aur "items" ke naam se use ho raha ho to bhi kaam karay
      items: state.items,
      count: state.items.reduce((sum, i) => sum + i.quantity, 0),
      subTotal,
      addItem: (product) => dispatch({ type: "ADD_ITEM", payload: product }),
      updateQuantity: (id, delta) =>
        dispatch({ type: "UPDATE_QUANTITY", payload: { id, delta } }),
      removeItem: (id) => dispatch({ type: "REMOVE_ITEM", payload: { id } }),
      clearCart: () => dispatch({ type: "CLEAR_CART" }),
    }),
    [state.items, subTotal]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used inside <CartProvider>");
  return ctx;
}